import React from 'react';
import { Box } from '@mui/material';
import { useOnline } from 'base-shell/lib/providers/Online';

import Page from 'layout/Page';
import Toolbar, { WithFixed } from 'components/Toolbar';

import { toolBarConfig } from 'config/toolbarConfig';

function AppShell() {
  const isOnline = useOnline();
  return (
    !isOnline && (
      <Page
        isAppBarVisible={true}
        toolbar={
          <WithFixed>
            <Toolbar buttons={toolBarConfig} current="" />
          </WithFixed>
        }
        title={'OFFLINE'}
      >
        <Box p={4}>
          <h2>No internet</h2>
          <h4>
            Try:
            <li>Checking the network cables, modem, and router</li>
            <li>Reconnecting to Wi-Fi</li>
            <div />
            ERR_INTERNET_DISCONNECTED
          </h4>
        </Box>
      </Page>
    )
  );
}
export default AppShell;
